<div class="main-container-position">
  <div class="container-width">
    <div class="mx-auto">
      <h1 i18n>Impressum</h1>

      <p class="text-lg mb-2">
        <strong i18n>Firma:</strong> Lebensbegleitung – Life Care eGen
      </p>
      <p class="text-lg mb-2">
        <strong i18n>Firmenbuchnummer:</strong> FN 595099 x
      </p>
      <p class="text-lg mb-2">
        <strong i18n>Firmenbuchgericht:</strong> Landesgericht Linz
      </p>
      <p class="text-lg mb-2">
        <strong i18n>Firmensitz (gemäß Firmenbucheintrag):</strong> 4020 Linz,
        Stelzhamerstraße 2/24
      </p>
      <p class="text-lg mb-2">
        <strong i18n>Rechtsform:</strong> Erwerbs- und Wirtschaftsgenossenschaft
        mit beschränkter Haftung
      </p>
      <p class="text-lg mb-6">
        <strong i18n>Vorstand:</strong> MMag. Wolfgang Bayer, Michael Schiemer,
        Dr. Johann Stroblmair
      </p>

      <h2 class="text-xl font-semibold mb-4" i18n="@@kontaktTitle">Kontakt</h2>
      <p class="text-lg mb-2"><strong i18n>Tel.:</strong> +43 664 3339723</p>
      <p class="text-lg mb-2">
        <strong i18n>E-Mail:</strong>
        <a href="mailto:office@sondis.at" class="text-blue-500 hover:underline">
          office&#64;sondis.at</a
        >
      </p>
    </div>
  </div>
</div>
